module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r8r5n1r-402716d8ea009636e691462af85d945e.svg";